import { useState } from 'react';
import { POLL } from '@/mocks/celebrity';

export default function Poll() {
  const [votes, setVotes] = useState(POLL.options.map((o) => o.votes));
  const [picked, setPicked] = useState<number | null>(null);
  const total = votes.reduce((s, v) => s + v, 0);

  const percent = (v: number) => (total ? Math.round((v / total) * 100) : 0);

  const vote = (idx: number) => {
    if (picked !== null) return;
    setPicked(idx);
    setVotes((prev) => prev.map((v, i) => (i === idx ? v + 1 : v)));
  };

  return (
    <section id="poll" className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 items-center gap-8 rounded-2xl border border-background-200 bg-gradient-to-br from-background-50 to-background-100 p-6 md:p-9 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-foreground-950">
            <i className="ri-bar-chart-2-line" />
            吃瓜投票站
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {POLL.question}
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            吃瓜不站队，投票才有灵魂。投出你的一票，看看全网网友跟你的直觉是否一致——结果实时累计。
          </p>
          <p className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-secondary-700">
            <i className="ri-team-line text-base" />
            已有 {total.toLocaleString()} 位吃瓜群众参与
          </p>
        </div>

        <div className="lg:col-span-7">
          <div className="space-y-3">
            {POLL.options.map((o, idx) => {
              const p = picked !== null ? percent(votes[idx]) : 0;
              const chosen = picked === idx;
              return (
                <button
                  key={o.label}
                  type="button"
                  onClick={() => vote(idx)}
                  disabled={picked !== null}
                  className={`relative w-full cursor-pointer overflow-hidden rounded-md border p-3 text-left transition-all disabled:cursor-default ${
                    chosen
                      ? 'border-primary-500'
                      : picked !== null
                        ? 'border-background-200'
                        : 'border-background-300 hover:border-primary-300'
                  }`}
                >
                  {picked !== null && (
                    <span
                      className={`absolute inset-y-0 left-0 ${chosen ? 'bg-primary-100' : 'bg-secondary-100/80'}`}
                      style={{ width: `${p}%` }}
                    />
                  )}
                  <span className="relative flex items-center justify-between gap-3">
                    <span className="flex items-center gap-2 text-sm font-medium text-foreground-900">
                      <i className={`${chosen ? 'ri-checkbox-fill' : 'ri-checkbox-blank-circle-line'} text-accent-600`} />
                      {o.label}
                    </span>
                    <span className="text-sm font-bold text-primary-600">{picked !== null ? `${p}%` : ''}</span>
                  </span>
                </button>
              );
            })}
          </div>
          {picked !== null && (
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-lock-2-line text-accent-600" />
              感谢参与，结果已实时计入总榜，可在下拉刷新查看全网趋势。
            </p>
          )}
        </div>
      </div>
    </section>
  );
}